import React, { FC, useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import CustomTooltip from '@/pages/IndustrialGreenMicBigScreen/components/CustomTooltip';
import { formatElectricity, keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import { Select } from '@maxtropy/components';
import {
  apiV2MicrogridOverviewGetBsaTodayInfoPost,
  V2MicrogridOverviewGetBsaTodayInfoPostResponse,
  V2MicrogridOverviewGetNewEnergyExistsPostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { useRequest } from 'ahooks';

interface ISVGBsaDataBox {
  leftTitle: string;
  dataExit?: V2MicrogridOverviewGetNewEnergyExistsPostResponse;
  getBsaData?: (val: V2MicrogridOverviewGetBsaTodayInfoPostResponse) => void;
}

const SVGBsaDataBox: FC<ISVGBsaDataBox> = props => {
  const { leftTitle, dataExit, getBsaData } = props;
  const bsaList = dataExit?.bsaList ?? [];
  const { microgridId } = useContext(ShareDataContext);
  const [bsaId, setBsaId] = useState<number>();
  const [bsaDetail, setBsaDetail] = useState<V2MicrogridOverviewGetBsaTodayInfoPostResponse>();

  // 默认选择第一个bsa
  useEffect(() => {
    if (!bsaList || bsaList.length === 0) {
      setBsaId(undefined);
    } else {
      setBsaId(bsaList[0].bsaId);
    }
  }, [bsaList]);

  // 储能数据
  const { data: bsaData } = useRequest(
    async () => {
      const res = await apiV2MicrogridOverviewGetBsaTodayInfoPost({
        id: Number(microgridId),
        bsaId,
      });
      return res;
    },
    {
      ready: !!microgridId && !!bsaId,
      refreshDeps: [microgridId, bsaId],
      pollingInterval: 1000 * 60,
    }
  );

  useEffect(() => {
    if (!bsaId) {
      setBsaDetail(undefined);
    } else {
      if (bsaData) {
        setBsaDetail(bsaData);
        getBsaData?.(bsaData);
      }
    }
  }, [bsaData, bsaId]);

  return (
    <div className={styles.yuan_box} id="svg-bsa-data-box">
      <div className={styles.left_top_bg}>{leftTitle}</div>
      <div className={styles.select_box}>
        <Select
          style={{ width: '100%', height: 26 }}
          placeholder={'请选择'}
          onChange={(v: number) => {
            setBsaId(v);
          }}
          value={bsaId}
          options={bsaList.map(item => ({
            label: item.bsaName,
            value: item.bsaId,
          }))}
          showSearch
          optionFilterProp="label"
          getPopupContainer={() => document.body}
        />
      </div>
      <div className={styles.capacity_box}>
        <div className={styles.label}>装机容量：</div>
        <CustomTooltip
          title={`${keepTwoOrLine(bsaDetail?.ratedPower)}MW/${keepTwoOrLine(bsaDetail?.installedCapacity)}MWh`}
        >
          <div className={styles.value}>
            {keepTwoOrLine(bsaDetail?.ratedPower)}MW/{keepTwoOrLine(bsaDetail?.installedCapacity)}MWh
          </div>
        </CustomTooltip>
      </div>

      <div className={styles[`line0`]}>
        <div className={styles.label}>{'今日充电量'}</div>
        <CustomTooltip title={`${formatElectricity(bsaDetail?.todayCharge)}`}>
          <div className={styles.value} style={{ color: '#16DD8E' }}>
            {formatElectricity(bsaDetail?.todayCharge)}
          </div>
        </CustomTooltip>
      </div>
      <div className={styles[`line1`]}>
        <div className={styles.label}>{'今日放电量'}</div>
        <CustomTooltip title={`${formatElectricity(bsaDetail?.todayDischarge)}`}>
          <div className={styles.value} style={{ color: '#00ADFF' }}>
            {formatElectricity(bsaDetail?.todayDischarge)}
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
};

export default SVGBsaDataBox;
